import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchData } from '../utils/fetchData'
import Content from '../components/layout/Content'
import MessageBox from '../components/MessageBox'
import { Media } from '../types/User'
import styles from '../styles/Login.module.css'

function Login () {
  const STORAGE_KEY = 'media'
  const navigate = useNavigate()
  const localStorageMedia = localStorage.getItem(STORAGE_KEY)
  let media: Media | null = null
  if (localStorageMedia) {
    try {
      media = JSON.parse(localStorageMedia)
    } catch (error) {
      console.log(error)
    }
  }
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [loginError, setLoginError] = React.useState(false)

  React.useEffect(() => {
    if (media && media?.token) {
      navigate('/')
    }
  }, [media, navigate])

  async function onLogin (e) {
    e.preventDefault()
    try {
      const res = await fetchData('/api/authentication/authenticate', {
        method: "POST",
        body: {
          email,
          password,
        }
      })

      if (res) {
        const { data, status } = res

        if (status === 200) {
          const { token, stores } = data || {}
          localStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
              token,
              stores,
            }),
          )
          navigate('/')
        } else if (status === 400) {
          setLoginError(true)
          console.log(data)
        }

      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div
      style={{
        backgroundImage: `url(/bg.jpeg)`,
      }}
      className={styles.login}
    >
      <Content>
        <div>
          <h1 className={styles.heading}>Mediabibliotek™</h1>
          <form onSubmit={onLogin} className={styles.form}>
            <div className={styles.formContent}>
              <MessageBox
                type='warning'
                withTitle={false}
                message='Observera att inloggning endast är tillgängligt med en giltig e-postadress och lösenord. Vänligen kontakta IT Support Butik om du saknar inloggningsuppgifter för e-postadress.'
              />
              <input
                value={email}
                className={loginError ? styles.inputError : styles.input}
                placeholder="E-postadress"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setLoginError(false)}
              />
              <input
                value={password}
                className={loginError ? styles.inputError : styles.input}
                placeholder="Lösenord"
                type="password"
                onChange={(e) => setPassword(e.target.value)}
                onFocus={() => setLoginError(false)}
              />
              {loginError &&
                <MessageBox
                  type='error'
                  withTitle={true}
                  title='Fel användarnamn eller lösenord'
                />
              }
              <button className={styles.button} onClick={onLogin}>
                Logga in
              </button>
            </div>
          </form>
        </div>
      </Content>
    </div>
  )
}

export default Login